import React from 'react';
import {StyleSheet, Pressable, View, Dimensions, Image} from 'react-native';
import Styles from '../../Styles';
import AVText from 'src/components/elements/AVText';
import {CampusLocationType} from 'src/types/CampusLocationTypes';
import ChevronRight from 'src/components/img/svg/ChevronRight';
import Localized from 'src/constants/AppStrings';
import {MachineType} from 'src/types/MachineType';
import {getDescriber} from './descriptor/DescriptorType';

type VendingLocationViewProps = {
  location: CampusLocationType;
  onLocationClick: (machine, autoAdvanced?: boolean) => Promise<void>;
  onPlanogramClick?: (machine: MachineType) => void;
};

const width = Dimensions.get('window').width;

const VendingLocationView = (props: VendingLocationViewProps) => {
  const {getVendingTile} = getDescriber();

  return (
    <Pressable
      accessible={true}
      onPress={() => props.onLocationClick(props.location)}
      accessibilityRole="button"
      accessibilityLabel={`Location${
        props.location.displayName ?? props.location.name
      }`}
      aria-label={`Location${
        props.location.displayName ?? props.location.name
      }`}
      nativeID={`Location${props.location.displayName ?? props.location.name}`}
      accessibilityHint={`Double tap to select ${
        props.location.displayName ?? props.location.name
      }`}
      style={styles.container}
    >
      <View style={styles.iconView}>
        <Image
          source={require('src/components/img/VendingDefaultIcon.png')}
          resizeMode="contain"
        />
      </View>
      <View style={styles.textView}>
        <AVText
          accessibilityLabel={`LocationName${
            props.location.displayName ?? props.location.name
          }`}
          accessibilityRole="text"
          aria-label={`${
            props.location.displayName ?? props.location.name
          }, text`}
          numberOfLines={1}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          style={getVendingTile().nameText}
        >
          {props.location.displayName ?? props.location.name}
        </AVText>
        <Pressable
          onPress={() => props.onPlanogramClick(props.location)}
          style={styles.nutritionalInfoButton}
          accessibilityLabel="View Nutritional Info"
          nativeID="View Nutritional Info"
          accessibilityRole="button"
        >
          <AVText style={getVendingTile().buttonText}>
            {Localized.Buttons.view_nutritional_info}
          </AVText>
        </Pressable>
      </View>
      <View style={styles.arrowView}>
        <ChevronRight color={Styles.darkColor} />
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    width: width - Styles.Spacing.m3 * 3,
    marginLeft: Styles.Spacing.m3,
    marginVertical: Styles.Spacing.m3,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: Styles.Spacing.m2,
    ...Styles.Style.shadow,
    minHeight: Styles.MinTouchableArea,
  },
  iconView: {
    borderTopLeftRadius: Styles.Spacing.m2,
    borderBottomLeftRadius: Styles.Spacing.m2,
    overflow: 'hidden',
  },
  textView: {
    flex: 1,
    justifyContent: 'center',
    paddingVertical: Styles.Spacing.m1,
    marginLeft: Styles.Spacing.m2 + Styles.Spacing.m1,
  },
  nutritionalInfoButton: {
    marginTop: Styles.Spacing.m2,
    paddingVertical: Styles.Spacing.m1,
    backgroundColor: 'transparent',
    borderRadius: 16,
    borderColor: Styles.Colors.PayNew.primary01,
    alignItems: 'center',
    borderWidth: 2,
    maxWidth: 175,
  },
  arrowView: {
    right: Styles.Spacing.m3,
    position: 'absolute',
  },
});

export default VendingLocationView;
